import BaseRepository from './base.repository';

class MedicationIntakeRepository extends BaseRepository {
  constructor() {
    super('/haven');
  }

  findAllIntake(params) {
    return this.client.get('/intake/', params);
  }

  recordIntake(intakeData) {
    return this.client.post('/intake/record', intakeData);
  }

  takeHistory(medicationUnique) {
    return this.client.get(`/intake/history/${medicationUnique}`);
  }
}

export default new MedicationIntakeRepository();
